import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkout-info"
export default class extends Controller {
  static targets = ["select", "stopAlert", "creditInfo", "debtValue", "limitValue", "bar", "pct", "remaining", "submitBtn"]
  static values  = { dsData: Object }

  connect() {
    this.update()
  }

  update() {
    const shopId = this.selectTarget.value
    const data   = shopId ? this.dsDataValue[shopId] : null

    if (!data) {
      this.stopAlertTarget.classList.add("d-none")
      this.creditInfoTarget.classList.add("d-none")
      this.submitBtnTarget.disabled = false
      return
    }

    this.stopAlertTarget.classList.toggle("d-none", !data.stop)
    this.submitBtnTarget.disabled = data.stop

    if (data.credit_limit != null) {
      const debt      = data.debt || 0
      const pct       = Math.min(Math.round(debt / data.credit_limit * 100), 100)
      const remaining = data.credit_limit - debt
      const barClass  = pct >= 90 ? "kit-progress__bar--danger" : (pct >= 70 ? "kit-progress__bar--warning" : "kit-progress__bar--success")

      this.debtValueTarget.textContent  = this.fmt(debt)
      this.limitValueTarget.textContent = this.fmt(data.credit_limit)
      this.barTarget.style.width        = pct + "%"
      this.barTarget.className          = "kit-progress__bar " + barClass
      this.pctTarget.textContent        = pct + "% использовано"
      this.remainingTarget.textContent  = "Доступно: " + this.fmt(Math.max(remaining, 0))
      this.remainingTarget.className    = remaining < 0 ? "text-caption" : "text-caption"
      this.remainingTarget.style.color  = remaining < 0 ? "var(--color-danger-text)" : ""

      if (pct >= 100) this.submitBtnTarget.disabled = true

      this.creditInfoTarget.classList.remove("d-none")
    } else {
      this.creditInfoTarget.classList.add("d-none")
    }
  }

  fmt(value) {
    return new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 }).format(value) + " ₽"
  }
}
